<template>
  <body>
    <div class="title-body">
      <div class="title">
        Turn Deadstock Into <br />
        Marketing Gold
      </div>
      <div class="title-text">
        A comprehensive social commerce platform that transforms dead <br />
        stock into revenue and free marketing without compromising your <br />
        brand integrity or the bottom line.
      </div>
      <a href="https://www.wecobi.com/login">
        <button class="getStarted">Get Started</button>
      </a>
    </div>
  </body>
</template>

<script>
export default {
  name: "Title",
};
</script>

<style scoped>
.title-body {
  margin-left: 108px;
  color: rgba(255, 255, 255, 1);
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.title {
  font-size: 65px;
  font-weight: 600;
  line-height: 1;
}
.title-text {
  font-size: 20px;
  font-weight: 500;
  line-height: 25px;
}
.getStarted {
  width: 187px;
  height: 50px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  background-color: rgba(255, 109, 10, 1);
  border: 2px solid rgba(255, 109, 10, 1);
  color: rgba(255, 255, 255, 1);
  padding: 14px 41px;
  border-radius: 30px;
  margin-right: 38px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.getStarted:hover {
  background-color: rgb(255, 126, 40);
  border: 2px solid rgb(255, 126, 40);
}

@media (max-width: 1280px) {
  .title-body {
    margin-left: 108px;
    padding-bottom: 60px;
  }

  .title {
    font-size: 50px;
  }
}

@media (max-width: 1024px) {
  .title-body {
    margin-left: 83px;
  }
  .title {
    font-size: 40px;
  }
}
@media (max-width: 744px) {
  .title-body {
    margin-left: 51px;
  }
  .title {
    font-size: 35px;
  }
}
@media (max-width: 451px) {
  .title-body {
    margin-left: 30px;
  }
  .title {
    font-size: 25px;
  }
}
</style>
